import { NavLink } from "react-router";
import styles from "./menu.module.css"
import classNames from "classnames";

export const MenuItem = ({ path = null, icon, text, onClick = () => {}, end=false }) => {
    if (path === null) {
        return (
            <div className={styles.menu_item} onClick={onClick}>
                <div className={styles.menu_item_icon}>
                    {icon}
                </div>
                <div className={styles.menu_item_name}>{text}</div>
            </div>
        );
    } else {
        return (
            <NavLink to={path} className={({ isActive }) => classNames(styles.menu_item, { [styles.active]: isActive })} viewTransition end={end}>
                <div className={styles.menu_item_icon}>
                    {icon}
                </div>
                <div className={styles.menu_item_name}>{text}</div>
            </NavLink>
        );
    }
}
